import { BuildingPackageType, BuildingPackageWorkflowStep } from './building-package';
export const LOAD_CALCULATION_WORKFLOW = [
    BuildingPackageWorkflowStep.PROCESSING_LOAD_CALCULATION_STEP,
    BuildingPackageWorkflowStep.PUBLISHED_LOAD_CALCULATION_STEP,
];
export function getWorkflowSequence(packageType) {
    switch (packageType) {
        case BuildingPackageType.LOAD_CALCULATION:
            return LOAD_CALCULATION_WORKFLOW;
        default:
            return null;
    }
}
export function hasNextStep(packageType, currentStep) {
    const sequence = getWorkflowSequence(packageType);
    if (!sequence)
        return false;
    const currentIndex = sequence.indexOf(currentStep);
    return currentIndex !== -1 && currentIndex < sequence.length - 1;
}
export function getNextStep(packageType, currentStep) {
    const sequence = getWorkflowSequence(packageType);
    if (!sequence)
        return null;
    const currentIndex = sequence.indexOf(currentStep);
    if (currentIndex === -1 || currentIndex >= sequence.length - 1)
        return null;
    return sequence[currentIndex + 1];
}
